import web from "@/core/middlewares/web";

let membersIndex = () => import(/* webpackChunkName: "members" */ '@/views/members/Index');
let membersCreate = () => import(/* webpackChunkName: "members" */ '@/views/members/Create');
let membersEdit = () => import(/* webpackChunkName: "members" */ '@/views/members/Edit');
let organizationsIndex = () => import(/* webpackChunkName: "organizations" */ '@/views/members/organizations/Index');
let organizationsCreate = () => import(/* webpackChunkName: "organizations" */ '@/views/members/organizations/Create');
let organizationsEdit = () => import(/* webpackChunkName: "organizations" */ '@/views/members/organizations/Edit');
let activityFields = () => import(/* webpackChunkName: "activity-fields" */ '@/views/members/activity-fields/Index');
let serviceScopes = () => import(/* webpackChunkName: "activity-fields" */ '@/views/members/service-scopes/Index');
let productsIndex = () => import(/* webpackChunkName: "products" */ '@/views/members/organizations/products/Index');
let productsCreate = () => import(/* webpackChunkName: "products" */ '@/views/members/organizations/products/Create');
let productsEdit = () => import(/* webpackChunkName: "products" */ '@/views/members/organizations/products/Edit');

export default [
    {
        path: "/members",
        name: "members.index",
        component: membersIndex,
        meta: {
            middleware: web,
            permissions: ['members:viewAny'],
            title: "اعضا"
        }
    },
    {
        path: "/members/create",
        name: "members.create",
        component: membersCreate,
        meta: {
            middleware: web,
            permissions: ['members:create'],
            title: "ایجاد عضو"
        }
    },
    {
        path: "/members/:id",
        name: "members.edit",
        component: membersEdit,
        meta: {
            middleware: web,
            permissions: ['members:view','members:update'],
            title: "ویرایش عضو"
        }
    },
    {
        path: "/organizations",
        name: "organizations.index",
        component: organizationsIndex,
        meta: {
            middleware: web,
            permissions: ['member-organizations:viewAny'],
            title: "سازمان ها"
        }
    },
    {
        path: "/organizations/create",
        name: "organizations.create",
        component: organizationsCreate,
        meta: {
            middleware: web,
            permissions: ['member-organizations:create'],
            title: "ایجاد سازمان"
        }
    },
    {
        path: "/organizations/:id",
        name: "organizations.edit",
        component: organizationsEdit,
        meta: {
            middleware: web,
            permissions: ['member-organizations:view','member-organizations:update'],
            title: "ویرایش سازمان"
        }
    },
    {
        path: "/organizations/:organization/products",
        name: "organizations.products.index",
        component: productsIndex,
        meta: {
            middleware: web,
            permissions: ['member-organizations:view','member-organizations:update'],
            title: "محصولات سازمان"
        }
    },
    {
        path: "/organizations/:organization/products/create",
        name: "organizations.products.create",
        component: productsCreate,
        meta: {
            middleware: web,
            permissions: ['member-organizations:update'],
            title: "ایجاد محصول سازمان"
        }
    },
    {
        path: "/organizations/:organization/products/:product/edit",
        name: "organizations.products.edit",
        component: productsEdit,
        meta: {
            middleware: web,
            permissions: ['member-organizations:update'],
            title: "ویرایش محصول سازمان"
        }
    },
    {
        path: "/activity-fields",
        name: "activity-fields.index",
        component: activityFields,
        meta: {
            middleware: web,
            permissions: ['activity-fields:viewAny'],
            title: "زمینه های فعالیت"
        }
    },
    {
        path: "/service-scopes",
        name: "service-scopes.index",
        component: serviceScopes,
        meta: {
            middleware: web,
            permissions: ['member-service-scopes:viewAny'],
            title: "محدوده خدمات"
        }
    },
]
